if(!customElements.get('custom-collection-product-list')){
    class CollectionProductList extends HTMLElement {

        constructor(){
            super();
            
            this.init();
        }

        init(){
            this.btnColumnSwitch = this.querySelector('.product-view-switch-wrapper');
            if(this.btnColumnSwitch){
                this.btnColumnSwitch.addEventListener('click', this.updateNumColumns.bind(this));
                this.btnColumnSwitch.addEventListener('keydown', e => {
                    if(e.key === 'Enter'){
                        this.updateNumColumns(e);
                    }
                });
            }
        }

        updateNumColumns(){
            this.productCardWrapper = this.querySelectorAll('.product-card__wrapper');

            this.productCardWrapper.forEach(item => {
                if(this.btnColumnSwitch.dataset.column == '3'){
                    // update to 4 columns
                    item.classList.add('col-xl-4');
                    item.classList.add('col-12');
                    item.classList.remove('col-xl-3');
                    item.classList.remove('col-6');
                }else{
                    // update to 3 columns
                    item.classList.add('col-xl-3');
                    item.classList.add('col-6');
                    item.classList.remove('col-xl-4');
                    item.classList.remove('col-12');
                }
            });

            if(this.btnColumnSwitch.dataset.column == '4'){
                this.btnColumnSwitch.setAttribute('data-column', '3');
            }else{
                this.btnColumnSwitch.setAttribute('data-column', '4');
            }
        }
    }

    customElements.define('custom-collection-product-list', CollectionProductList);
}